import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const ReviewSettingsV1 = z.object({
  stars: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]),
  minimal: z.union([z.literal(true), z.literal(false)]),
  bottomAuthor: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
})

export type TReviewSettingsV1 = z.infer<typeof ReviewSettingsV1>

export const ReviewElementV1 = z.object({
  id: z.string(),
  name: z.literal("review"),
  settings: ReviewSettingsV1,
  container: ContainerOptionsV1,
})

export type TReviewElementV1 = z.infer<typeof ReviewElementV1>

// Latest ---------------------
export const ReviewSettings = ReviewSettingsV1
export type TReviewSettings = TReviewSettingsV1
export const ReviewElement = ReviewElementV1
export type TReviewElement = TReviewElementV1
